import React, { useState, useEffect, useRef } from "react";
import { GiHamburgerMenu } from "react-icons/gi";
import { FiSearch, FiHeart, FiShoppingCart, FiUser } from "react-icons/fi";
import logo from "../../assets/logo-trans.png";
import logo_aswad from "../../assets/logo-aswad.png"
import logoscrolled from "../../assets/logo-aswad.png";
import "./Header.css";
import { Link, useLocation, useNavigate } from "react-router-dom";
import UserModal from "../User/UserModal";
import CartDrawer from "../Cart/CartDrawer";
import { useCart } from "../Cart/CartContext";
import api from "../../api"
import { useModal } from "../../ModalContext";
import { CgDanger } from "react-icons/cg";
import NoImg from "../../assets/no-track.avif"


const Navbar = ({ likesCount = 3, avatarSrc = null }) => {
  const [menuOpen, setMenuOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);
  const [search, setSearch] = useState("");
  const [showUserModal, setShowUserModal] = useState(false);
  const searchBoxRef = useRef(null);
  const { openModal } = useModal();

  const location = useLocation();
  const navigate = useNavigate();
  const isHome = location.pathname === "/" || location.pathname === "/CheckOut" || location.pathname === "/TermsConditions" || location.pathname === "/cart" || location.pathname.startsWith("/products/") || location.pathname.startsWith("/artist/") || location.pathname.startsWith("/payment-success");
  const linkColor = scrolled ? "black" : isHome ? "black" : "black";
  const hoverColor = isHome ? "#fff" : "#b1b1b1"
  const logoSrc = isHome ? logo_aswad : logo;
  const { cartItems, addToCart, removeItem, increaseQty, decreaseQty } = useCart();
  //const cartCount = cartItems.length;
  const cartCount = cartItems.reduce((total, item) => total + item.qty, 0);
  const [cartOpen, setCartOpen] = useState(false);
  const [searchResults, setSearchResults] = useState([]);
  const [showResults, setShowResults] = useState(false);
  const [searchLoading, setSearchLoading] = useState(false);

  useEffect(() => {
    // const handleScroll = () => {
    //   const carouselHeight =
    //     document.querySelector(".carousel-container")?.offsetHeight || 100;
    //   setScrolled(window.scrollY > carouselHeight - 80);
    // };
    const handleScroll = () => {
      const triggerHeight = location.pathname === "/ImmortalSection"
        ? window.innerHeight
        : location.pathname === "/aboutus"
          ? window.innerHeight * 0.5
          : window.innerHeight * 0.6;
      setScrolled(window.scrollY > triggerHeight);
    };

    window.addEventListener("scroll", handleScroll, { passive: true });
    return () => window.removeEventListener("scroll", handleScroll);
  }, [location]);

  // Close CartDrawer when navigating to CheckOut
  useEffect(() => {
    if (location.pathname === "/CheckOut" || location.pathname === "/cart") {
      setCartOpen(false);
    }
  }, [location.pathname]);

  const buttons = [
    { title: "Home", to: "/" },
    { title: "About Us", to: "/aboutus" },
    { title: "The Immortal Collection", to: "/ImmortalSection" },
    { title: "Shop", to: "/shop" },
    // { title: "Cart", to: "/cart" },
    { title: "Checkout", to: "/CheckOut" },
    { title: "Contact Us", to: "/contact-us" },
  ];

  // const onSubmitSearch = (e) => {
  //   e.preventDefault();
  //   const q = search.trim();
  //   if (!q) return;

  //   // change this route if you want another page
  //   navigate(`/shop?q=${encodeURIComponent(q)}`);
  //   setMenuOpen(false);
  // };

  useEffect(() => {
    const q = search.trim();

    if (!q) {
      setSearchResults([]);
      setShowResults(false);
      setSearchLoading(false);
      return;
    }

    const timer = setTimeout(async () => {
      try {
        setSearchLoading(true);

        const res = await api.get(
          `search/search-products?q=${encodeURIComponent(q)}`
        );

        const results = Array.isArray(res.data) ? res.data : [];
        setSearchResults(results);
        setShowResults(true);
      } catch (error) {
        console.error("Search failed:", error);
        setSearchResults([]);
        setShowResults(false);
      } finally {
        setSearchLoading(false);
      }
    }, 300);

    return () => clearTimeout(timer);
  }, [search]);

  useEffect(() => {
    const handleClickOutside = (e) => {
      if (searchBoxRef.current && !searchBoxRef.current.contains(e.target)) {
        setShowResults(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  // const onSubmitSearch = (e) => {
  //   e.preventDefault();
  //   if (!search.trim()) return;
  //   setShowResults(true);
  // };
  const onSubmitSearch = (e) => {
    e.preventDefault();
    if (!search.trim()) return;
    navigate("/search", {
      state: {
        query: search,
        allProducts: searchResults,
      },
    });

    setShowResults(false);
    setMenuOpen(false);
  };
  const handleResultClick = (item) => {
    setSearch("");
    setShowResults(false);
    setMenuOpen(false);
    navigate(`/products/${item.id}`);
  };

  const handleCheckout = () => {
    if (cartCount === 0) {
      openModal(
        <CgDanger size={40} color="#993400" />,
        "Your cart is empty.",
        "Add some items before checking out.",
      );
      return;
    }
    else {
      navigate("/CheckOut");
    }
  };

  const renderSearchResults = () => {
    if (!showResults) return null;

    return (
      <div className="search-dropdown">
        <div className="search-dropdown-inner">
          {searchLoading ? (
            <div className="search-result-item search-result-text-only">
              Searching...
            </div>
          ) : searchResults.length > 0 ? (
            searchResults.map((item) => (
              <button
                key={item.id}
                type="button"
                className="search-result-item"
                onClick={() => handleResultClick(item)}
              >
                <img
                  src={
                    item.cover_front && item.cover_front !== "N|A"
                      ? `https://api.righttrack.com.lb/assets/images/${item.cover_front}`
                      : NoImg
                  }
                  alt={item.titleEn || item.titleAr || "Product cover"}
                  className="search-result-img"
                  onError={(e) => {
                    e.target.onerror = null; // prevent infinite loop
                    e.target.src = NoImg;
                  }}
                />

                <div className="search-result-content">
                  <div className="search-result-title">
                    {item.titleEn || item.titleAr}
                  </div>
                  <div className="search-result-artist">
                    {item.artistEn || item.artistAr}
                  </div>
                </div>
              </button>
            ))
          ) : (
            <div className="search-result-item search-result-text-only">
              No results found
            </div>
          )}
        </div>
      </div>
    );
  };

  return (
    <div className={`navbarr ${scrolled ? "scrolled" : ""}`}>
      <div className="navbar-container" style={{ direction: "ltr" }}>
        {/* LEFT: Logo */}
        <Link to="/" className="logo">
          <img
            src={scrolled ? logoscrolled : logoSrc}
            alt="logo"
            style={{ width: "9rem" }}
            loading="lazy"
          />
        </Link>

        {/* CENTER: Desktop Menu */}
        <ul
          className={`navList ${menuOpen ? "open" : ""} ${scrolled ? "scrolled" : ""
            }`}
        >
          {/* MOBILE: Search inside drawer */}
          <li className="mobile-only">
            <div className="search-box-wrapper" ref={searchBoxRef}>
              <form className="search-pill mobile" onSubmit={onSubmitSearch}>
                <FiSearch className="search-ic" />
                <input
                  value={search}
                  onChange={(e) => setSearch(e.target.value)}
                  onFocus={() => {
                    if (search.trim()) setShowResults(true);
                  }}
                  placeholder="Search..."
                // onKeyDown={(e) => {
                //   if (e.key === "Enter") {
                //     e.preventDefault();
                //     if (!search.trim()) return; 
                //     navigate("/search", {
                //       state: {
                //         query: search,
                //         allProducts: searchResults
                //       }
                //     });

                //     setShowResults(false);
                //   }
                // }}
                />
              </form>
              {renderSearchResults()}
            </div>
          </li>

          {buttons.map((item, index) => {
            const isActive = location.pathname === item.to;

            const handleClick = (e) => {
              if (item.title === "Checkout") {
                if (cartCount === 0) {
                  e.preventDefault();
                  handleCheckout();
                  return;
                }
              }

              if (item.section && location.pathname === "/") {
                e.preventDefault();
                document
                  .querySelector(item.section)
                  ?.scrollIntoView({ behavior: "smooth" });
              }

              setMenuOpen(false);
            };

            return (
              <Link
                to={item.to}
                key={index}
                className={`navItem ${isActive ? "active" : ""}`}
                style={{ "--hoverColor": hoverColor, textDecoration: "none" }}
                onClick={handleClick}
              >
                <div
                  className="navLink"
                  style={{ color: linkColor }}
                >
                  {item.title}
                </div>
              </Link>
            );
          })}

          {/* MOBILE: icons row inside drawer */}
        </ul>

        {/* RIGHT: Desktop Actions */}
        <div className="navbar-right">
          <div className="search-box-wrapper" ref={searchBoxRef}>
            <form className="search-pill desktop" onSubmit={onSubmitSearch}>
              <FiSearch className="search-ic" />
              <input
                value={search}
                onChange={(e) => setSearch(e.target.value)}
                onFocus={() => {
                  if (search.trim()) setShowResults(true);
                }}
                placeholder="Search..."
              />
            </form>
            {renderSearchResults()}
          </div>

          {/* <Link className="icon-btn-header" to="/wishlist" aria-label="Wishlist">
            <FiHeart />
            {likesCount > 0 && <span className="badge">{likesCount}</span>}
          </Link> */}

          <button onClick={() => setCartOpen(true)} className="icon-btn-header" /*to="/cart"*/ data-cart-target
  /*to="/cart"*/ aria-label="Cart">
            <FiShoppingCart />
            {cartCount > 0 && <span className="badge">{cartCount}</span>}
          </button>

          {/* <Link className="avatar-btn" to="/account" aria-label="Account">
            {avatarSrc ? <img src={avatarSrc} alt="Account" /> : <FiUser />}
          </Link> */}
          <button
            className="avatar-btn"
            onClick={() => {
              setMenuOpen(false);
              setShowUserModal(true);
            }}
          >
            {avatarSrc ? <img src={avatarSrc} alt="Account" /> : <FiUser />}
          </button>
        </div>

        {/* MOBILE: Hamburger */}
        {/* MOBILE: Cart + Avatar + Hamburger */}
        <div className="mobile-right">
          <button
            className="icon-btn-header"
            onClick={() => {
              setMenuOpen(false);
              setCartOpen(true);
            }}
            aria-label="Cart"
            data-cart-target
          >
            <FiShoppingCart />
            {cartCount > 0 && <span className="badge">{cartCount}</span>}
          </button>

          <button
            className="avatar-btn"
            onClick={() => {
              setMenuOpen(false);
              setShowUserModal(true);
            }}
            aria-label="Account"
          >
            {avatarSrc ? <img src={avatarSrc} alt="Account" /> : <FiUser />}
          </button>

          {/* MOBILE: Hamburger */}
          <div className="menuIcon" onClick={() => setMenuOpen(!menuOpen)}>
            <GiHamburgerMenu size={24} color={scrolled ? "#a0a4af" : "#993400"} />
          </div>
        </div>


        {menuOpen && (
          <div className="navbar-overlay" onClick={() => setMenuOpen(false)} />
        )}
        <UserModal
          isOpen={showUserModal}
          onClose={() => setShowUserModal(false)}
        />
        <CartDrawer
          isOpen={cartOpen}
          onClose={() => setCartOpen(false)}
          items={cartItems}
          onRemoveItem={removeItem}
          onIncreaseQty={increaseQty}
          onDecreaseQty={decreaseQty}
          onViewCart={() => navigate("/cart")}
          onCheckout={handleCheckout}
          onContinueShopping={() => setCartOpen(false)}
        />
      </div>
    </div>
  );
};

export default Navbar;
